import React, { FC } from 'react'
import { Box } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
// import { TradeHistory } from '../TreasurySections/TradeHistory'
import { TradingHistory } from '../../SpotTrading/TradingHistory'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}))

export const Trades: FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <TradingHistory />
    </Box>
  )
}
